import { ReactNode } from 'react';
import { IconClock } from '../../../../icon/IconClock';
import { IconDeclinedFilled } from '../../../../icon/IconDeclinedFilled';
import { IconEyeFilled } from '../../../../icon/IconEyeFilled';
import { IconLimited } from '../../../../icon/IconLimited';
import { IconText } from '../../../../icon/IconText';
import { PostStatus } from '../../../constants';

export const COLOR_MAPPING: Record<PostStatus, string> = {
    [PostStatus.PUBLISHED]: 'var(--color-success)',
    [PostStatus.LIMITED]: 'var(--color-warning)',
    [PostStatus.MODERATION]: 'var(--badge-draft)',
    [PostStatus.DECLINED]: 'var(--color-danger)',
    [PostStatus.DELETED]: 'var(--color-danger)',
    [PostStatus.DRAFT]: 'var(--badge-draft)',
};

export const ICON_MAPPING: Record<PostStatus, ReactNode> = {
    [PostStatus.PUBLISHED]: <IconEyeFilled size={20} fill="var(--always-white)" margin="auto" />,
    [PostStatus.LIMITED]: <IconLimited size={20} fill="var(--always-white)" margin="auto" />,
    [PostStatus.MODERATION]: <IconClock size={20} fill="var(--always-white)" margin="auto" />,
    [PostStatus.DECLINED]: (
        <IconDeclinedFilled size={20} fill="var(--always-white)" margin="auto" />
    ),
    [PostStatus.DELETED]: <IconDeclinedFilled size={20} fill="var(--always-white)" margin="auto" />,
    [PostStatus.DRAFT]: <IconText size={20} fill="var(--always-white)" margin="auto" />,
};

export const TOOLTIP_TEXT_MAPPING: Record<PostStatus, string> = {
    [PostStatus.PUBLISHED]: 'Опубликован',
    [PostStatus.LIMITED]: 'Частично отклонен',
    [PostStatus.MODERATION]: 'На модерации',
    [PostStatus.DECLINED]: 'Отклонен модерацией',
    [PostStatus.DELETED]: 'Удален',
    [PostStatus.DRAFT]: 'Черновик',
};
